
export default function calculatePrice(unitLevels, selections, unit_price, po_unit) {
  let totalPrice = 0;

  for (const { unit, value } of selections) {
    if (unit === po_unit) {
        // If the selected unit is the same as the price unit, use direct multiplication
        totalPrice += unit_price * value;
      } else {
      const selectedUnitLevel = unitLevels.find(level => level.unit === unit);
      if (!selectedUnitLevel) {
          continue;
      }

      const poUnitIndex = unitLevels.findIndex(level => level.unit === po_unit);
      const selectedUnitIndex = unitLevels.findIndex(level => level.unit === unit);

      let conversionFactor = 1;
      let isPoUnitTopLevel = poUnitIndex === 0;

      for (let i = 0; i < unitLevels.length; i++) {
          const level = unitLevels[i];

          if (isPoUnitTopLevel) {
              if (i < selectedUnitIndex) {
                  conversionFactor /= level.value;
              } else if (i === selectedUnitIndex) {
                  conversionFactor /= level.value;
                  break;
              }
          } else {
              if (i < poUnitIndex) {
                  conversionFactor *= level.value;
              } else if (i === poUnitIndex) {
                  conversionFactor *= level.value;
              } else if (i > poUnitIndex && i <= selectedUnitIndex) {
                  conversionFactor /= level.value;
              } else if (i === selectedUnitIndex) {
                  conversionFactor /= level.value;
                  break;
              }
          }
      }

      const price = unit_price * conversionFactor;
      const selectionPrice = price * value;
      totalPrice += selectionPrice;
  }}

  return Number(totalPrice.toFixed(2));
}